import {Record} from 'immutable';
import {schema} from 'normalizr';
import {WorkflowSchema} from './Workflow';

const ThreadType = Record({
    id: null,
    name: null,
    code: null,
    workflow: null,
    header: null,
    footer: null,
});

export const ThreadTypeSchema = new schema.Entity('threadTypes', {
    workflow: WorkflowSchema,
});

export default ThreadType;
